import React, { useState, useEffect } from 'react';
import { Alert, Button, Dropdown, DropdownButton, Form, InputGroup, Modal,Col,Row } from 'react-bootstrap';
import { getPuestosByLocalId } from '../../../../../crud/management_api/puestos';
import { toast } from 'react-toastify';
import { faInfoCircle, faEye, faEyeSlash, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChevronLeft, X } from 'react-bootstrap-icons';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { initMenuDefaultByLocalId } from '../../../../../crud/menu_api/menus';
import { initStorageUnitsDefaultByLocalId } from '../../../../../crud/management_api/storage_units';
import './CreateUser.scss';

interface CreateUserProps {
    index: number;
    moveFunctions: { next: () => void; back: () => void };
    setPayload: (data: any) => void;
    accountCode: string;
}

const CreateUser: React.FC<CreateUserProps> = ({ index, moveFunctions, setPayload, accountCode }) => {
    const storedData = JSON.parse(localStorage.getItem('RegistrationMemory') || '{}');
    const companyData = storedData[0] || {};
    const localData = storedData[1] || {};
    const userLSData = storedData[4] || {};
    const [error, setError] = useState<string | null>(null);

    const [puestosData, setPuestosData] = useState<any[]>([]);
    const [userData, setUserData] = useState({
        username: userLSData.username || '',
        password: userLSData.password || '',
        email: companyData.company_email || '',
        middle_name: ' ',
        last_name: userLSData.last_name || '',
        phone_number: userLSData.phone_number || '',
        address: userLSData.address || '',
        dob: userLSData.dob || '',
        local_id: localData.local_id || '',
        company_id: companyData.company_id || '',
        puesto_id: '',
        rol_id: 1,
    });

    // Password visibility and confirmation states
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordTouched, setPasswordTouched] = useState(false);
    const passwordsMatch = userData.password === confirmPassword;

    // Calendar states
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date | null>(
      userData.dob ? new Date(userData.dob) : null
    );
    const toggleCalendar = () => setShowCalendar(prev => !prev);

    useEffect(() => {
        if (localData.local_id) {
            const timer = setTimeout(() => {
                getPuestosByLocalId(localData.local_id)
                    .then((response) => {
                        setPuestosData(response.data);
                        console.log('Respuesta de puestos:', response.data);
                    })
                    .catch((error) => {
                        console.error('Error al cargar los puestos:', error);
                    });
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            toast.error('No se encontró local_id en localStorage');
        }
    }, [localData.local_id]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setUserData(prev => ({ ...prev, [name]: value }));
        if (error) setError(null);
    };

    const handlePuestoSelect = (puesto_id: string) => {
        setUserData(prev => ({ ...prev, puesto_id }));
    };

    const validateForm = () => {
        if (!userData.username || !userData.last_name || !userData.email || !userData.password || !confirmPassword || !userData.dob || !userData.address || !userData.phone_number ) {
            setError('Todos los campos son requeridos.');
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(userData.email)) {
            setError('El correo electrónico debe contener una "@"');
            return false;
        }
        if (userData.password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return false;
        }
        setError(null);
        return true;
    };

    const handleNext = () => {
        if (validateForm()) {
            const updatedData = { ...userData, code: accountCode };
            setPayload(updatedData);
            // Guardar credenciales para login
            initMenuDefaultByLocalId(localData.local_id);
            initStorageUnitsDefaultByLocalId(localData.local_id);
            localStorage.setItem('newCreatedUser', JSON.stringify({ email: userData.email, password: userData.password }));
            moveFunctions.next();
        }
    };

    

    return (
    <div className='container-CreateUser'>
      <div className="logo-container-preg">
        <img src="/logos/Recurso 40MEDIOPUNTO.png" alt="Logo Mediopunto" className="registration-logo-preg" />
      </div>
      <div className="info-guide-preg">
        <h2 className="Title-Step-Registration-preg">Crea un usuario</h2>
        <p><FontAwesomeIcon icon={faInfoCircle} size="sm" className="info-icon" /> ¡Has llegado al paso final! Completa los campos.</p>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}
      <Form className='form-createUser'>
        <div className='form-column'>
          <Form.Control
            type="text"
            name="username"
            value={userData.username}
            onChange={handleInputChange}
            className="input-createUser"
            placeholder="Nombre"
          />
          <Form.Control
            type="email"
            name="email"
            value={userData.email}
            onChange={handleInputChange}
            className="input-createUser"
            placeholder="Correo electrónico"
          />
          <div className='fecha-container'>
            <Form.Label>Fecha de cumpleaños</Form.Label>
            <Button variant="none" onClick={toggleCalendar} className="mp-button light">
              {selectedDate ? selectedDate.toLocaleDateString('es-ES') : ''} <FontAwesomeIcon icon={faCalendar} />
            </Button>
          </div>
          <Form.Control
            type="text"
            name="phone_number"
            value={userData.phone_number}
            onChange={handleInputChange}
            className="input-createUser"
            placeholder="Número de teléfono"
          />
        </div>


        
        <div className='form-column'>
          <Form.Control
            type="text"
            name="last_name"
            value={userData.last_name}
            onChange={handleInputChange}
            className="input-createUser"
            placeholder="Apellidos"
          />
          <InputGroup>
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={userData.password}
              onChange={handleInputChange}
              className="input-createUser"
              placeholder="Contraseña"
            />
            <Button variant="none" className='eye-password-registration' onClick={() => setShowPassword(prev => !prev)}>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </Button>
          </InputGroup>
          <InputGroup>
            <Form.Control
              type={showConfirmPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={e => {
                setConfirmPassword(e.target.value);
                setPasswordTouched(true);
              }}
              className="input-createUser"
              placeholder="Confirmar Contraseña"
            />
              <Button variant="none" className='eye-password-registration' onClick={() => setShowConfirmPassword(prev => !prev)}>
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
              </Button>
            </InputGroup>
          <Form.Control
            type="text"
            name="address"
            value={userData.address}
            onChange={handleInputChange}
            className="input-createUser"
            placeholder="Dirección"
          />
        </div>

        {/* Puesto - centrado */}

      </Form>
      <div className="button-group">
          <Button className="BackStep_Registration-preg" variant="none" onClick={moveFunctions.back}>
            <ChevronLeft /> Anterior
          </Button>
          <Button className="NextStep_Registration-preg" variant="none" onClick={handleNext}>
            Finalizar
          </Button>
      </div>

      <Modal show={showCalendar} onHide={toggleCalendar} centered className='modal-birthdate'>
        <Modal.Header>
          <Modal.Title>Selecciona Fecha de Nacimiento</Modal.Title>
          <Button variant="none" onClick={toggleCalendar}><X /></Button>
        </Modal.Header>
        <Modal.Body>
          <Calendar
            onChange={date => {
              const sel = date as Date;
              setSelectedDate(sel);
              setUserData(prev => ({ ...prev, dob: sel.toLocaleDateString('en-CA') }));
              toggleCalendar();
            }}
            value={selectedDate}
            locale="es-ES"
            className="mp-form-calendar"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateUser;
